import React, { useEffect, useState } from "react"
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import AuthService from "../../../../../api/AuthService";
import OtherIncomePage from "../../../../../entities/DashboardPage/AccountingModule/OtherIncome/AddOtherIncome";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../../../../../context/AlertContext";


const AddOtherIncome = () => {
  const [banks, setBanks] = useState();
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const {showAlert} = useAlert()
  const [types, setTypes] = useState()

  useEffect(() => {
    getAllBanks()
    getExpenseType("Income")
  },[])
  const getAllBanks = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getAllBanks();
      if (result?.success) {
        setBanks(result?.data?.bankAccounts);
        LoaderHelper.loaderStatus(false);
      } else { 
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const addOtherIncome = async (data,type,date,paymentMode,bankDetails,files) => {
    setLoading(true);
    try {
      const result = await AuthService.addOtherIncome(data,type,date,paymentMode,bankDetails,files);
      if (result?.success === true) {
        setLoading(false);
        showAlert(result?.message, "success");
        navigate("/dashboard/otherIncome")
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error?.message, "error");
    }
  };

  const getExpenseType = async (type) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getExpenseType(type);
      if (result?.success) {
        setTypes(result?.data?.types);
        LoaderHelper.loaderStatus(false);
      } else { 
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  return(
    <>
      <OtherIncomePage loading={loading} types={types} addOtherIncome={addOtherIncome} banks={banks}/>
    </>
  )
}

export default AddOtherIncome